import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Heart, Home, PartyPopper } from "lucide-react";

export default function DonationSuccess() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md"
      >
        <Card className="bg-card border-accent/30">
          <CardContent className="p-8 text-center">
            {/* Celebration Icon */}
            <motion.div
              animate={{ 
                scale: [1, 1.2, 1],
                rotate: [0, 10, -10, 0]
              }}
              transition={{ duration: 1.5, repeat: Infinity }}
              className="w-24 h-24 mx-auto mb-6 rounded-full bg-accent/20 flex items-center justify-center"
            >
              <PartyPopper className="h-12 w-12 text-accent" />
            </motion.div>
            
            {/* Title */}
            <h1 className="text-3xl font-black uppercase tracking-tighter mb-2">
              Thank You!
            </h1>
            
            <p className="text-muted-foreground mb-6">
              Your donation means the world to us. You're helping keep Coach Coop SHRED running and supporting our community.
            </p>
            
            {/* Heart animation */}
            <div className="flex justify-center gap-2 mb-8">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  animate={{ y: [0, -10, 0] }}
                  transition={{ duration: 0.5, delay: i * 0.15, repeat: Infinity }}
                >
                  <Heart className="h-6 w-6 text-pink-500 fill-pink-500" />
                </motion.div>
              ))}
            </div>
            
            {/* Back Home */}
            <Link to="/">
              <Button className="w-full bg-primary hover:bg-primary/90 uppercase font-bold tracking-widest">
                <Home className="mr-2 h-4 w-4" />
                Back to Home
              </Button>
            </Link>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
